module.exports = __webpack_public_path__ + "img/view-more-active.3939d05a.png";